export default "__VITE_ASSET__CMx$xLCU__"